import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'opensource',
  `
    SET_OPENSOURCE_SORT

    UPDATE_OPENSOURCE_FILTER
    SET_OPENSOURCE_FILTER
    CLEAR_OPENSOURCE_FILTER
  `
);
